import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
import { ProductPriceRangeFragmentDoc } from '../../fragments/__generated__/ProductPriceRange.generated';
import { FeedbackBaseFragmentDoc } from '../../fragments/__generated__/Feedback.generated';
import { ProductVariantPriceRangeFragmentDoc } from '../../fragments/__generated__/ProductVariantPriceRange.generated';
import { CategoryBaseFragmentDoc } from '../../fragments/__generated__/Category.generated';
import { RewardProgramFragmentDoc } from '../../fragments/__generated__/RewardProgram.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ProductReflectionPickerDataQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  limitFeedback?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  offsetFeedback?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type ProductReflectionPickerDataQuery = { specific: { id: string, pk: number, isArchive: boolean, name: string, description: string, slug: string, product: { id: string, pk: number, name: string, metaDescription: string, keywords: string, tag: string, sku: string | null, ean: string, upc: string, isbn: string, isShippingRequired: boolean, isInFavorites: boolean, isArchive: boolean, redirectUrl: string | null, hasVariants: boolean, weight: number | null, height: number | null, width: number | null, length: number | null, showVariantWeight: boolean, showVariantLength: boolean, showVariantEan: boolean, showVariantIsbn: boolean, showVariantUpc: boolean, showVariantSku: boolean, isSkuVisible: boolean, isEanVisible: boolean, isIsbnVisible: boolean, isUpcVisible: boolean, isWeightVisible: boolean, isLengthVisible: boolean, isInStock: boolean, manufacturer: { id: string, name: string } | null, priceRange: { id: string, currency: string, discount: { max: number, min: number }, undiscount: { max: number, min: number } }, images: Array<{ id: string, alt: string, thumbnailUrl: string | null, url: string }>, feedbacks: { totalCount: number, pageInfo: { offset: number, limit: number | null }, results: Array<{ id: string, pk: number, title: string, comment: string, score: number, userName: string, timeCreated: any, url: string }> }, variants: Array<{ pk: number, id: string, sku: string, name: string, ean: string, upc: string, isbn: string, isSupply: boolean, isPublished: boolean, weightOverride: number | null, lengthOverride: number | null, widthOverride: number | null, heightOverride: number | null, stockQuantity: number, unitCoeff: number | null, shippingRequired: boolean, outOfStockStatus: Types.OutOfStockStatusEnum, isInCart: boolean, priceRange: { id: string, currency: string, discount: { max: number, min: number }, undiscount: { max: number, min: number } }, properties: Array<{ id: number, attributeName: string, valueName: string }>, images: Array<{ id: string, pk: number, alt: string, thumbnailUrl: string | null, url: string }> }> } | null } | null };

export type ProductReflectionFeedbacksQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  limit: Types.Scalars['Int']['input'];
  offset: Types.Scalars['Int']['input'];
  sortBy: Array<Types.FeedbackOrder> | Types.FeedbackOrder;
}>;


export type ProductReflectionFeedbacksQuery = { specific: { id: string, product: { id: string, feedbacks: { totalCount: number, pageInfo: { offset: number, limit: number | null }, results: Array<{ id: string, pk: number, title: string, comment: string, score: number, userName: string, timeCreated: any, url: string, salesChannel: { id: string, name: string } }> } } | null } | null };

export type ProductReflectionCategoriesQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type ProductReflectionCategoriesQuery = { specific: { id: string, pk: number, name: string, categories: Array<{ id: string, name: string, url: string, pk: number, slug: string, description: string, metaDescription: string, keywords: string, metaTitle: string, level: number, isWholesale: boolean }> } | null };

export type ReflectionPickerDataQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  limitFeedback?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  offsetFeedback?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type ReflectionPickerDataQuery = { reflectionDetails: { redirectUrl: string | null, reflection: { id: string, pk: number, isArchive: boolean, name: string, description: string, videoUrl: string | null, slug: string, product: { id: string, pk: number, name: string, metaDescription: string, keywords: string, tag: string, sku: string | null, ean: string, upc: string, isbn: string, isShippingRequired: boolean, isInFavorites: boolean, isArchive: boolean, redirectUrl: string | null, hasVariants: boolean, weight: number | null, height: number | null, width: number | null, length: number | null, showVariantWeight: boolean, showVariantLength: boolean, showVariantEan: boolean, showVariantIsbn: boolean, showVariantUpc: boolean, showVariantSku: boolean, isSkuVisible: boolean, isEanVisible: boolean, isIsbnVisible: boolean, isUpcVisible: boolean, isWeightVisible: boolean, isLengthVisible: boolean, isInStock: boolean, isInPack: boolean, zipfileLink: string, manufacturer: { id: string, name: string } | null, priceRange: { id: string, currency: string, discount: { max: number, min: number }, undiscount: { max: number, min: number } }, images: Array<{ id: string, alt: string, thumbnailUrl: string | null, url: string }>, feedbacks: { totalCount: number, pageInfo: { offset: number, limit: number | null }, results: Array<{ id: string, pk: number, title: string, comment: string, score: number, userName: string, timeCreated: any, url: string }> }, variants: Array<{ pk: number, id: string, sku: string, name: string, ean: string, upc: string, isbn: string, isSupply: boolean, isPublished: boolean, weightOverride: number | null, lengthOverride: number | null, widthOverride: number | null, heightOverride: number | null, stockQuantity: number, unitCoeff: number | null, shippingRequired: boolean, outOfStockStatus: Types.OutOfStockStatusEnum, isInCart: boolean, priceRange: { id: string, currency: string, discount: { max: number, min: number }, undiscount: { max: number, min: number } }, properties: Array<{ id: number, attributeName: string, valueName: string }>, images: Array<{ id: string, pk: number, alt: string, thumbnailUrl: string | null, url: string }> }>, rewardPrograms: Array<{ id: string, pk: number, availableFrom: any | null, availableTo: any | null, coefficient: number, dateCreated: any, daysActive: number, name: string, description: string, isActive: boolean, rdThreshold: number | null, rpThreshold: number, thumbnailUrl: string | null }> } | null } | null } | null };


export const ProductReflectionPickerDataDocument = gql`
    query ProductReflectionPickerData($id: ID!, $limitFeedback: Int = 100, $offsetFeedback: Int = 1) {
  specific(id: $id) {
    id
    pk
    isArchive
    name
    description
    slug
    product {
      id
      pk
      name
      metaDescription
      keywords
      tag
      sku
      ean
      upc
      isbn
      isShippingRequired
      isInFavorites
      isArchive
      redirectUrl
      hasVariants
      weight
      height
      width
      length
      showVariantWeight
      showVariantLength
      showVariantEan
      showVariantIsbn
      showVariantUpc
      showVariantSku
      isSkuVisible
      isEanVisible
      isIsbnVisible
      isUpcVisible
      isWeightVisible
      isLengthVisible
      isInStock
      manufacturer {
        id
        name
      }
      priceRange {
        ...ProductPriceRangeFragment
      }
      images {
        id
        alt
        url: image
        thumbnailUrl(size: "600x0", method: CROP_WEBP)
      }
      feedbacks(pagination: {limit: $limitFeedback, offset: $offsetFeedback}) {
        totalCount
        pageInfo {
          offset
          limit
        }
        results {
          ...FeedbackBaseFragment
        }
      }
      variants {
        pk
        id
        sku
        name
        ean
        upc
        isbn
        isSupply
        isPublished
        weightOverride
        lengthOverride
        widthOverride
        heightOverride
        stockQuantity
        unitCoeff
        shippingRequired
        outOfStockStatus
        isInCart
        priceRange {
          ...ProductVariantPriceRangeFragment
        }
        properties {
          id
          attributeName
          valueName
        }
        images {
          id
          pk
          alt
          url: image
          thumbnailUrl(size: "600x0", method: CROP_WEBP)
        }
      }
    }
  }
}
    ${ProductPriceRangeFragmentDoc}
${FeedbackBaseFragmentDoc}
${ProductVariantPriceRangeFragmentDoc}`;

/**
 * __useProductReflectionPickerDataQuery__
 *
 * To run a query within a React component, call `useProductReflectionPickerDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductReflectionPickerDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductReflectionPickerDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limitFeedback: // value for 'limitFeedback'
 *      offsetFeedback: // value for 'offsetFeedback'
 *   },
 * });
 */
export function useProductReflectionPickerDataQuery(baseOptions: Apollo.QueryHookOptions<ProductReflectionPickerDataQuery, ProductReflectionPickerDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductReflectionPickerDataQuery, ProductReflectionPickerDataQueryVariables>(ProductReflectionPickerDataDocument, options);
      }
export function useProductReflectionPickerDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductReflectionPickerDataQuery, ProductReflectionPickerDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductReflectionPickerDataQuery, ProductReflectionPickerDataQueryVariables>(ProductReflectionPickerDataDocument, options);
        }
export type ProductReflectionPickerDataQueryHookResult = ReturnType<typeof useProductReflectionPickerDataQuery>;
export type ProductReflectionPickerDataLazyQueryHookResult = ReturnType<typeof useProductReflectionPickerDataLazyQuery>;
export type ProductReflectionPickerDataQueryResult = Apollo.QueryResult<ProductReflectionPickerDataQuery, ProductReflectionPickerDataQueryVariables>;
export function refetchProductReflectionPickerDataQuery(variables: ProductReflectionPickerDataQueryVariables) {
      return { query: ProductReflectionPickerDataDocument, variables: variables }
    }
export const ProductReflectionFeedbacksDocument = gql`
    query ProductReflectionFeedbacks($id: ID!, $limit: Int!, $offset: Int!, $sortBy: [FeedbackOrder!]!) {
  specific(id: $id) {
    id
    product {
      id
      feedbacks(pagination: {limit: $limit, offset: $offset}, ordering: $sortBy) {
        totalCount
        pageInfo {
          offset
          limit
        }
        results {
          ...FeedbackBaseFragment
          salesChannel {
            id
            name
          }
        }
      }
    }
  }
}
    ${FeedbackBaseFragmentDoc}`;

/**
 * __useProductReflectionFeedbacksQuery__
 *
 * To run a query within a React component, call `useProductReflectionFeedbacksQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductReflectionFeedbacksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductReflectionFeedbacksQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useProductReflectionFeedbacksQuery(baseOptions: Apollo.QueryHookOptions<ProductReflectionFeedbacksQuery, ProductReflectionFeedbacksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductReflectionFeedbacksQuery, ProductReflectionFeedbacksQueryVariables>(ProductReflectionFeedbacksDocument, options);
      }
export function useProductReflectionFeedbacksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductReflectionFeedbacksQuery, ProductReflectionFeedbacksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductReflectionFeedbacksQuery, ProductReflectionFeedbacksQueryVariables>(ProductReflectionFeedbacksDocument, options);
        }
export type ProductReflectionFeedbacksQueryHookResult = ReturnType<typeof useProductReflectionFeedbacksQuery>;
export type ProductReflectionFeedbacksLazyQueryHookResult = ReturnType<typeof useProductReflectionFeedbacksLazyQuery>;
export type ProductReflectionFeedbacksQueryResult = Apollo.QueryResult<ProductReflectionFeedbacksQuery, ProductReflectionFeedbacksQueryVariables>;
export function refetchProductReflectionFeedbacksQuery(variables: ProductReflectionFeedbacksQueryVariables) {
      return { query: ProductReflectionFeedbacksDocument, variables: variables }
    }
export const ProductReflectionCategoriesDocument = gql`
    query ProductReflectionCategories($id: ID!) {
  specific(id: $id) {
    id
    pk
    name
    categories {
      ...CategoryBaseFragment
    }
  }
}
    ${CategoryBaseFragmentDoc}`;

/**
 * __useProductReflectionCategoriesQuery__
 *
 * To run a query within a React component, call `useProductReflectionCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductReflectionCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductReflectionCategoriesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProductReflectionCategoriesQuery(baseOptions: Apollo.QueryHookOptions<ProductReflectionCategoriesQuery, ProductReflectionCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductReflectionCategoriesQuery, ProductReflectionCategoriesQueryVariables>(ProductReflectionCategoriesDocument, options);
      }
export function useProductReflectionCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductReflectionCategoriesQuery, ProductReflectionCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductReflectionCategoriesQuery, ProductReflectionCategoriesQueryVariables>(ProductReflectionCategoriesDocument, options);
        }
export type ProductReflectionCategoriesQueryHookResult = ReturnType<typeof useProductReflectionCategoriesQuery>;
export type ProductReflectionCategoriesLazyQueryHookResult = ReturnType<typeof useProductReflectionCategoriesLazyQuery>;
export type ProductReflectionCategoriesQueryResult = Apollo.QueryResult<ProductReflectionCategoriesQuery, ProductReflectionCategoriesQueryVariables>;
export function refetchProductReflectionCategoriesQuery(variables: ProductReflectionCategoriesQueryVariables) {
      return { query: ProductReflectionCategoriesDocument, variables: variables }
    }
export const ReflectionPickerDataDocument = gql`
    query ReflectionPickerData($id: ID!, $limitFeedback: Int = 100, $offsetFeedback: Int = 1) {
  reflectionDetails(id: $id) {
    redirectUrl
    reflection {
      id
      pk
      isArchive
      name
      description
      videoUrl
      slug
      product {
        id
        pk
        name
        metaDescription
        keywords
        tag
        sku
        ean
        upc
        isbn
        isShippingRequired
        isInFavorites
        isArchive
        redirectUrl
        hasVariants
        weight
        height
        width
        length
        showVariantWeight
        showVariantLength
        showVariantEan
        showVariantIsbn
        showVariantUpc
        showVariantSku
        isSkuVisible
        isEanVisible
        isIsbnVisible
        isUpcVisible
        isWeightVisible
        isLengthVisible
        isInStock
        isInPack
        zipfileLink
        manufacturer {
          id
          name
        }
        priceRange {
          ...ProductPriceRangeFragment
        }
        images {
          id
          alt
          url: image
          thumbnailUrl(size: "600x0", method: CROP_WEBP)
        }
        feedbacks(pagination: {limit: $limitFeedback, offset: $offsetFeedback}) {
          totalCount
          pageInfo {
            offset
            limit
          }
          results {
            ...FeedbackBaseFragment
          }
        }
        variants {
          pk
          id
          sku
          name
          ean
          upc
          isbn
          isSupply
          isPublished
          weightOverride
          lengthOverride
          widthOverride
          heightOverride
          stockQuantity
          unitCoeff
          shippingRequired
          outOfStockStatus
          isInCart
          priceRange {
            ...ProductVariantPriceRangeFragment
          }
          properties {
            id
            attributeName
            valueName
          }
          images {
            id
            pk
            alt
            url: image
            thumbnailUrl(size: "600x0", method: CROP_WEBP)
          }
        }
        rewardPrograms {
          ...RewardProgramFragment
        }
      }
    }
  }
}
    ${ProductPriceRangeFragmentDoc}
${FeedbackBaseFragmentDoc}
${ProductVariantPriceRangeFragmentDoc}
${RewardProgramFragmentDoc}`;

/**
 * __useReflectionPickerDataQuery__
 *
 * To run a query within a React component, call `useReflectionPickerDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useReflectionPickerDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReflectionPickerDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limitFeedback: // value for 'limitFeedback'
 *      offsetFeedback: // value for 'offsetFeedback'
 *   },
 * });
 */
export function useReflectionPickerDataQuery(baseOptions: Apollo.QueryHookOptions<ReflectionPickerDataQuery, ReflectionPickerDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReflectionPickerDataQuery, ReflectionPickerDataQueryVariables>(ReflectionPickerDataDocument, options);
      }
export function useReflectionPickerDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReflectionPickerDataQuery, ReflectionPickerDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReflectionPickerDataQuery, ReflectionPickerDataQueryVariables>(ReflectionPickerDataDocument, options);
        }
export type ReflectionPickerDataQueryHookResult = ReturnType<typeof useReflectionPickerDataQuery>;
export type ReflectionPickerDataLazyQueryHookResult = ReturnType<typeof useReflectionPickerDataLazyQuery>;
export type ReflectionPickerDataQueryResult = Apollo.QueryResult<ReflectionPickerDataQuery, ReflectionPickerDataQueryVariables>;
export function refetchReflectionPickerDataQuery(variables: ReflectionPickerDataQueryVariables) {
      return { query: ReflectionPickerDataDocument, variables: variables }
    }